import { IPitch } from "../types";

export const solfaParser: IPitch["s"][] = [1, 3, 5, 0, 2, 4, 6];